/**
 * Client-origin error (non-HTTP) with ProblemDetails-compatible fields.
 * Use via helper `injectError` to ensure consistent creation and logging.
 */
export class ClientError extends Error {
    public readonly status: number;
    public readonly statusText: string;
    public readonly type?: string;
    public readonly instance?: string;
    public readonly context?: Record<string, unknown>;

    constructor(
        spec: { status: number; statusText: string },
        opts?: {
            type?: string;
            instance?: string;
            name?: string;
            context?: Record<string, unknown>;
        }
    ) {
        super(spec.statusText);
        this.name = opts?.name ?? 'ClientError';
        this.status = spec.status;
        this.statusText = spec.statusText;
        this.type = opts?.type;
        this.instance = opts?.instance;
        this.context = opts?.context;
    }
}
